import { useEffect, useState } from 'react';

import { useGlobalDialog } from "../../../Store/DialogManager";

import { useSnackbar } from "notistack";
import styled from 'styled-components';

import { useRolesHook } from '../../../Hooks/Maintenance/Accessibilities/rolesHooks';

import { Role, AddEditRoleModalInterface } from '../../../Models/Maintenance/Accessibilities/Roles';

import RequiredParametersHelper from '../../../Utilities/Helpers/RequiredParametersHelper';
import RequiredFieldHelper from '../../../Utilities/Helpers/RequiredFieldHelper';
import QueryBuilderHelper from '../../../Utilities/Helpers/QueryBuilderHelper';

import { ButtonType } from '../../../Utilities/Enums/ButtonTypeEnum';
import { RolesField } from '../../../Utilities/Enums/ParametersEnum';
import { CachingEnum } from '../../../Utilities/Enums/CachingEnum';

import CustomButton from '../../../CustomViews/Elements/CustomButton';
import FormTextField from '../../../CustomViews/Elements/FormTextField';
import AutoCompleteDropdown from '../../../CustomViews/Elements/AutoCompleteDropdown';

const ModalContentContainer = styled.div <{ $darkMode?: boolean; }>`
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    width: 30vw;
`;

export default function AddEditRoleModal(props: AddEditRoleModalInterface) {
    let { openAddEditModal, setopenAddEditModal, selectedRole, setselectedRole } = props;
    const { enqueueSnackbar } = useSnackbar();
    const { setDialogContent, setOpenGlobalDialog } = useGlobalDialog();
    let requiredFields = RequiredParametersHelper.roles();

    //Use States
    let [errorMessages, setErrorMessages]: any = useState({});
    const [queryStr, setQueryStr] = useState({
        pageSize: QueryBuilderHelper.DefaultPageSizeValue(),
        pageNumber: QueryBuilderHelper.DefaultPageNumValue(),
        searchString: QueryBuilderHelper.DefaultSearchValue(),
    });

    const q_queryKey = [CachingEnum.ACCESSIBILITIES, queryStr]
    const { DropdownData, dropdownFetchStatus, createRole, editRoleById } = useRolesHook(q_queryKey, queryStr, false);


    const nameProps = {
        name: RolesField.NAME,
        title: 'Name',
        fieldValue: selectedRole?.[RolesField.NAME] ?? "",
        type: 'text',
        required: requiredFields?.find((field: any) => field.keyName == RolesField.NAME)?.keyName != null,
        errorMessages: errorMessages,
        handleOnChange: (selectedValue: any) => {
            if(setselectedRole) {
                setselectedRole(prev => ({ ...prev, [RolesField.NAME]: selectedValue }));
            }
        },
    },
        descriptionProps = {
            name: RolesField.DESCRIPTION,
            title: 'Description',
            fieldValue: selectedRole?.[RolesField.DESCRIPTION] ?? "",
            type: 'text',
            required: requiredFields?.find((field: any) => field.keyName == RolesField.DESCRIPTION)?.keyName != null,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                if(setselectedRole) {
                    setselectedRole(prev => ({ ...prev, [RolesField.DESCRIPTION]: selectedValue }));
                }
            },
        },
        typeProps = {
            name: RolesField.TYPE,
            title: 'Role Type',
            fieldValue: selectedRole?.[RolesField.TYPE] ?? "",
            options: DropdownData?.[CachingEnum.ROLE_TYPE_LIST] ?? [],
            isLoadingDropdown: dropdownFetchStatus ?? false,
            required: requiredFields?.find((field: any) => field.keyName == RolesField.TYPE)?.keyName != null,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                if(setselectedRole) {
                    setselectedRole((prev: any) => ({ ...prev, [RolesField.TYPE]: selectedValue?.id ?? '' }));
                }
            },
        },
        statusProps = {
            name: RolesField.STATUS,
            title: 'Status',
            fieldValue: selectedRole?.[RolesField.STATUS] ?? "",
            options: DropdownData?.[CachingEnum.STATUS_LIST] ?? [],
            isLoadingDropdown: dropdownFetchStatus ?? false,
            required: requiredFields?.find((field: any) => field.keyName == RolesField.STATUS)?.keyName != null,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                if(setselectedRole) {
                    setselectedRole((prev: any) => ({ ...prev, [RolesField.STATUS]: selectedValue?.id ?? '' }));
                }
            },
        };

    //Event Handlers
    const onCloseDialog = async (e: any = null) => {
        if(e) {
            e.preventDefault();
        }

        if(setopenAddEditModal) {
            setopenAddEditModal(false);
        }

        if(setselectedRole) {
            setselectedRole(new Role());
        }

        setOpenGlobalDialog(false);
    }

    useEffect(() => {
        if(openAddEditModal) {
            setDialogContent({
                title: (!selectedRole?.[RolesField.PUBLIC_ID] ? "Add" : "Edit") + " Role",
                clearDialog: onCloseDialog,
                onCloseDialog: onCloseDialog,
                actionButtons: renderActionButtons(),
                children: renderDialogContent(),
            });
        }
    }, [openAddEditModal, selectedRole, errorMessages]);

    const handleSubmit = async () => {
        let _validateForm = RequiredFieldHelper.validateForm(requiredFields, selectedRole, errorMessages, setErrorMessages, enqueueSnackbar);

        if (_validateForm?.hasError) { return true; }

        let _success: boolean = false;

        if(!selectedRole?.[RolesField.PUBLIC_ID]) {
            let createResponse = await createRole(JSON.stringify(selectedRole));
            
            _success = createResponse?.isSuccess ?? false;
        } else {
            let editResponse = await editRoleById(selectedRole?.[RolesField.PUBLIC_ID], JSON.stringify(selectedRole));
            
            _success = editResponse?.isSuccess ?? false;
        }

        if(_success) {
            onCloseDialog();
        }
    }

    //Rendering Functions
    const renderActionButtons = () => {
        return <>
            <CustomButton
                btnType={ButtonType.CANCEL}
                title='Close'
                onClick={(e: any) => {
                    onCloseDialog(e);
                }} />

            <CustomButton
                btnType={ButtonType.SUCCESS}
                title='Save'
                onClick={(e: any) => {
                    handleSubmit();
                }} />
        </>
    }

    const renderDialogContent = () => {
        return <ModalContentContainer>
            <FormTextField {...nameProps} />
            <FormTextField {...descriptionProps} />
            <AutoCompleteDropdown {...typeProps} />
            <AutoCompleteDropdown {...statusProps} />
        </ModalContentContainer>
    }

    return <></>
}